export function hasVerticalScrollbar(element) {
  if (!element) {
    return false;
  }

  return element.scrollHeight > element.clientHeight;
}
